<template>
  <b-row
    id="dePara"
    align-v="center"
    no-gutters
  >
    <b-col class="pr-1">
      <data-input
        :ref="'dataInicio'"
        v-model="valueInner.dataInicio"
        class="start-date"
        :invalid="invalid"
        :show-icon="false"
        :placeholder="'Data inicial'"
      />
    </b-col>
    <b-col>
      <data-input
        :ref="'dataFim'"
        v-model="valueInner.dataFim"
        class="end-date"
        :invalid="invalid"
        :show-icon="false"
        :disabled="!valueInner.dataInicio"
        :placeholder="'Data final'"
        :disabled-dates="disabledDates"
      />
    </b-col>
  </b-row>
</template>

<style lang="scss">
#dePara {
  .start-date input.form-control {
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .end-date input.form-control {
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
}
</style>

<script>
/* eslint-disable func-names */

import Vue from 'vue'
import moment from 'moment'

export default {
  name: 'DePara',
  components: {
    'data-input': () => import('@/shared/components/data-input/DataInput.vue'),
  },
  props: {
    requiredEnd: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      valueInner: {
        dataInicio: null,
        dataFim: null,
      },
      disabledDates: {},
    }
  },
  watch: {
    value: {
      deep: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.valueInner = value
        }
      },
    },
    'valueInner.dataFim': function (value, oldValue) {
      if (value && !this.valueInner.dataFim) {
        this.invalidDataInicio = true
      } else {
        this.invalidDataInicio = false
      }

      if (value !== oldValue) {
        this.$emit('input', { dataInicio: this.valueInner.dataInicio, dataFim: value })
      }
    },
    'valueInner.dataInicio': function (value, oldValue) {
      const date = moment(value, 'DD/MM/YYYY').toDate()
      Vue.set(this.disabledDates, 'to', date)
      if (!value && this.valueInner.dataFim) {
        this.valueInner.dataFim = null
      }

      if (value !== oldValue) {
        this.$emit('input', { dataInicio: value, dataFim: this.valueInner.dataFim })
      }
    },
  },
  focus() {
    this.$refs.dataInicio.$el.focus()
  },
  created() {
    this.valueInner = this.value
  },
}
</script>
